import React, { useEffect, useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { toast } from 'react-toastify';
import Select from 'react-select';

import Header from "../components/Header";

import { createUser, getUser } from "../auth/Auth";
import { loadUsers } from "../common/Common";
import { postRequest, uploadFile } from "../routes/Routes";

import avatar from "../assets/images/avatar.png";

import '../assets/css/ManageAdmins.css';

function ManageAdmins() {
    const [user, setUser] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [success, setSuccess] = useState({});
    const [isMobile, setIsMobile] = useState(false);
    const [addAdmin, setAddAdmin] = useState(false);
    const [sendLoading, setSendLoading] = useState(false);
    const [profileImage, setProfileImage] = useState(null);
    const uploadProfileImageInput = React.createRef();

    useEffect(() => {
        getUser().then((data) => {
            setUser(data);

            const values = {
                context: {
                    action: 'List Admins'
                },
                endpoint: '/api/user/list-admins',
                token: data.token
            };
            loadUsers(values)
                .then(users => {
                    const filtered = users.filter(user => user?.role?.roleId !== 1);
                    setUsers(filtered);
                    setFilteredUsers(filtered);
                })
                .catch(() => null);
        }).catch(() => null);
    }, []);


    useEffect(() => {
        const updateMedia = () => setIsMobile(window.innerWidth < 768);
        updateMedia();
        window.addEventListener('resize', updateMedia);
        return () => window.removeEventListener('resize', updateMedia);
    }, []);

    const filterUsers = (text) => {
        let filteredUsers;
        if (text === '') {
            filteredUsers = users;
        } else {
            text = text.toLowerCase();
            filteredUsers = users.filter((user) => `${user.firstName}`.toLowerCase().includes(text) || `${user.lastName}`.toLowerCase().includes(text) || `${user.email}`.toLowerCase().includes(text));
        }
        setFilteredUsers(filteredUsers);
    };

    const userBody = (users) => {
        let body = [];
        // const activeUsers = users.filter(user => user.isEnabled);

        if (users.length === 0) {
            body.push(
                <div key="noUsers" className="no-users">No Active Admins</div>
            );
        }

        users.forEach((user, index) => {
            body.push(
                <div key={index}
                    onClick={() => {
                        setSelectedUser(user);
                        setAddAdmin(false);
                        setError({ error: false, message: null });
                        setSuccess({ success: false, message: null });
                    }}
                    className={selectedUser && selectedUser.email === user.email ? 'active-user' : ''}>
                    {user.firstName}
                    <hr className="active-hr" />
                </div>
            );
        });

        return body;
    };


    const handleChange = (event, key) => {
        setSelectedUser(values => ({
            ...values,
            [key]: event.target.value
        }));
    }

    const formSubmit = (event) => {
        setLoading(true);
        event.preventDefault();

        const dto = {
            email: selectedUser?.email?.trim() || '',
            firstName: selectedUser?.firstName?.trim() || '',
            lastName: selectedUser?.lastName?.trim() || '',
            addressLineOne: selectedUser?.addressLineOne?.trim() || '',
            addressLineTwo: selectedUser?.addressLineTwo?.trim() || '',
            city: selectedUser?.city?.trim() || '',
            postcode: selectedUser?.postcode?.trim() || '',
        };

        if (addAdmin) {
            dto.authProvider = 'RCACCOUNTING';
        }

        const values = {
            dto,
            context: {
                action: addAdmin ? 'Create Admin' : 'Update Admin'
            },
            endpoint: addAdmin ? '/api/user/create-admin' : '/api/user/update',
            token: user.token
        };

        postRequest(values).then(response => {

            if (response.status === 200) {
                if (addAdmin) {
                    const newUser = { ...response.data };
                    setUsers(prev => [...prev, newUser]);
                    setFilteredUsers(prev => [...prev, newUser]);
                    setSelectedUser(newUser);
                    setAddAdmin(false);
                } else {
                    setUsers(prev =>
                        prev.map(u => u.email === selectedUser.email ? { ...response.data } : u)
                    );
                    setFilteredUsers(prev =>
                        prev.map(u => u.email === selectedUser.email ? { ...response.data } : u)
                    );
                    setSelectedUser({ ...response.data });

                    if (selectedUser.email === user.email) {
                        createUser({ ...response.data, token: user.token }).then(() => {
                            window.location.href = '/';
                        });
                    }
                }

                setError({ error: false, message: null });
                setSuccess({ success: true, message: 'Successfully updated admin' });
            } else {
                setError({
                    error: true,
                    errorMessage: response.data.message || "An error occurred!"
                });
            }

            setLoading(false);
        });
    };


    const deleteAdmin = () => {
        let values = {
            dto: {
                email: selectedUser.email,
                isEnabled: false,
            },
            context: {
                action: 'Update Admin'
            },
            endpoint: '/api/user/update',
            token: user.token
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                setUsers(values =>
                    values.filter(function (user) {
                        return user.email !== selectedUser.email;
                    }),
                );
                setFilteredUsers(values =>
                    values.filter(function (user) {
                        return user.email !== selectedUser.email;
                    }),
                );
                setSelectedUser(null);
                toast.success('Successfully deleted Admin', {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("An error occurred!", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        });
    }

    const addAdminButton = () => {
        setAddAdmin(true);
        setSelectedUser({
            email: '',
            firstName: '',
            lastName: '',
            addressLineOne: '',
            addressLineTwo: '',
            city: '',
            postcode: '',
        });
        setError(values => ({ ...values, error: false, message: null }));
        setSuccess(values => ({ ...values, success: false, message: null }));
    };


    const sendInvitation = () => {
        setSendLoading(true);

        let values = {
            dto: {
                user: {
                    email: selectedUser.email,
                }
            },
            context: {
                action: 'Send Invitation'
            },
            endpoint: '/api/user-invitation/send',
            token: user.token
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                toast.success(response.data.message, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setSelectedUser({ ...selectedUser, userInvitation: true });
            } else {
                toast.error("An error occurred!", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }).finally(() => setSendLoading(false));
    }

    const uploadProfileImage = (event) => {
        event.preventDefault();
        const data = new FormData();
        data.append('file', uploadProfileImageInput.current.files[0]);
        uploadFile(data, '/api/user/upload?user=' + selectedUser.email, { token: user.token }).then(response => {
            if (response.status !== 200) {
                toast.error("An error occurred!", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            toast.success("Successfully uploaded profile image", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setUsers(values =>
                values.map(user => {
                    if (user.email === selectedUser.email) {
                        return { ...response.data };
                    }
                    return user;
                }),
            );
            setFilteredUsers(values =>
                values.map(user => {
                    if (user.email === selectedUser.email) {
                        return { ...response.data };
                    }
                    return user;
                }),
            );
            setSelectedUser({ ...response.data });
            setProfileImage(null);
            if (selectedUser.email === user.email) {
                response.data = { ...response.data, token: user.token };
                createUser(response.data).then(() => {
                    window.location.href = '/';
                });
            }
        });
    }

    if (user) {
        return (
            <>
                <Header component="Manage Admins" addAdminButton={addAdminButton} />
                <div className="grey-background full-height">
                    <div className="container">
                        <div className="d-flex name-container">
                            <div className="p-2">Admin Panel</div>
                            <div className="p-2 desktop-admin-search">
                                <ScrollContainer>
                                    <div className="name-list-container">
                                        {userBody(filteredUsers)}
                                    </div>
                                </ScrollContainer>
                            </div>
                            <div className="p-2 desktop-admin-search">
                                <input type="label" placeholder='Search Admins' className='search-input'
                                    onChange={(event) => filterUsers(event.target.value)} />
                            </div>
                            <div className="p-2 mobile-admin-search">
                                <Select
                                    className="basic-single btn w-100 select user-select"
                                    id="primaryUser" options={users}
                                    onChange={(event) => {
                                        setSelectedUser(event);
                                        setAddAdmin(false);
                                        setError(values => ({ ...values, error: false, message: null }));
                                        setSuccess(values => ({ ...values, success: false, message: null }));
                                    }}
                                    defaultValue={selectedUser}
                                    getOptionValue={option => option['email']}
                                    getOptionLabel={option => option['firstName']} />
                            </div>
                        </div>
                        {(selectedUser || addAdmin) &&
                            <div className="admin-detail-container">
                                <div className="d-flex admin-image-container">
                                    <div>
                                        {selectedUser && selectedUser.imageUrl ?
                                            <img src={selectedUser.imageUrl} alt={selectedUser.firstName}
                                                className='user-image' />
                                            : <img src={avatar} alt="Avatar" className='user-image' />
                                        }
                                    </div>
                                    <div className="d-flex">
                                        <div className="admin-name">
                                            {selectedUser ? (selectedUser.firstName ? selectedUser.firstName : '') + ' ' + (selectedUser.lastName ? selectedUser.lastName : '') : null}
                                            <p>
                                                PNG or JPG no bigger than 1000px wide and tall.
                                            </p>
                                        </div>
                                        <div>
                                            <button className='borderless-button' data-bs-toggle="modal"
                                                data-bs-target="#profileImageModal"
                                                disabled={!(selectedUser && selectedUser.hasOwnProperty('lastUpdated'))}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor"
                                                    className="bi bi-upload" viewBox="0 0 16 16">
                                                    <path
                                                        d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                    <path
                                                        d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                                </svg>
                                                Upload
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="'d-flex">
                                    <form onSubmit={formSubmit} className="admin-form-container">
                                        <h3 className="form-heading">Admin Information</h3>
                                        <div className="d-flex desktop-user-form">
                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="firstName">First Name*</label>
                                                    <input type="text" className="form-control" name="firstName"
                                                        value={selectedUser ? selectedUser.firstName : ''}
                                                        onChange={(event) => handleChange(event, 'firstName')}
                                                        placeholder="Type first name"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="email">Email*</label>
                                                    <input type="email" className="form-control" name="email"
                                                        disabled={selectedUser && selectedUser.hasOwnProperty('lastUpdated')}
                                                        value={selectedUser ? selectedUser.email : ''}
                                                        onChange={(event) => handleChange(event, 'email')}
                                                        placeholder="Type email"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="addressLineTwo">Address Line Two</label>
                                                    <input type="text" className="form-control" name="addressLineTwo"
                                                        value={selectedUser ? selectedUser.addressLineTwo : ''}
                                                        onChange={(event) => handleChange(event, 'addressLineTwo')}
                                                        placeholder="Type address line two" />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="postcode">Postcode*</label>
                                                    <input type="text" className="form-control" name="postcode"
                                                        value={selectedUser ? selectedUser.postcode : ''}
                                                        onChange={(event) => handleChange(event, 'postcode')}
                                                        placeholder="Type postcode"
                                                        required />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="lastName">Last Name*</label>
                                                    <input type="text" className="form-control" name="lastName"
                                                        value={selectedUser ? selectedUser.lastName : ''}
                                                        onChange={(event) => handleChange(event, 'lastName')}
                                                        placeholder="Type last name"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="addressLineOne">Address Line One*</label>
                                                    <input type="text" className="form-control" name="addressLineOne"
                                                        value={selectedUser ? selectedUser.addressLineOne : ''}
                                                        onChange={(event) => handleChange(event, 'addressLineOne')}
                                                        placeholder="Type address line one"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="city">City*</label>
                                                    <input type="text" className="form-control" name="city"
                                                        value={selectedUser ? selectedUser.city : ''}
                                                        onChange={(event) => handleChange(event, 'city')}
                                                        placeholder="Type city"
                                                        required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mobile-user-form">
                                            <div className="form-group">
                                                <label htmlFor="firstName">First Name*</label>
                                                <input type="text" className="form-control" name="firstName"
                                                    value={selectedUser ? selectedUser.firstName : ''}
                                                    onChange={(event) => handleChange(event, 'firstName')}
                                                    placeholder="Type first name"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="lastName">Last Name*</label>
                                                <input type="text" className="form-control" name="lastName"
                                                    value={selectedUser ? selectedUser.lastName : ''}
                                                    onChange={(event) => handleChange(event, 'lastName')}
                                                    placeholder="Type last name"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="email">Email*</label>
                                                <input type="email" className="form-control" name="email"
                                                    disabled={selectedUser && selectedUser.hasOwnProperty('lastUpdated')}
                                                    value={selectedUser ? selectedUser.email : ''}
                                                    onChange={(event) => handleChange(event, 'email')}
                                                    placeholder="Type email"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="addressLineOne">Address Line One*</label>
                                                <input type="text" className="form-control" name="addressLineOne"
                                                    value={selectedUser ? selectedUser.addressLineOne : ''}
                                                    onChange={(event) => handleChange(event, 'addressLineOne')}
                                                    placeholder="Type address line one"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="addressLineTwo">Address Line Two</label>
                                                <input type="text" className="form-control" name="addressLineTwo"
                                                    value={selectedUser ? selectedUser.addressLineTwo : ''}
                                                    onChange={(event) => handleChange(event, 'addressLineTwo')}
                                                    placeholder="Type address line two" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="city">City*</label>
                                                <input type="text" className="form-control" name="city"
                                                    value={selectedUser ? selectedUser.city : ''}
                                                    onChange={(event) => handleChange(event, 'city')}
                                                    placeholder="Type city"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="postcode">Postcode*</label>
                                                <input type="text" className="form-control" name="postcode"
                                                    value={selectedUser ? selectedUser.postcode : ''}
                                                    onChange={(event) => handleChange(event, 'postcode')}
                                                    placeholder="Type postcode"
                                                    required />
                                            </div>
                                        </div>
                                        {success.success &&
                                            <div className="alert alert-success" role="alert">
                                                {success.message}
                                            </div>}
                                        {error.error &&
                                            <div className="alert login-alert alert-danger" role="alert">
                                                {error.errorMessage}
                                            </div>}

                                        {!isMobile ? (
                                            <div className="d-flex admin-form-button-container">
                                                {selectedUser?.hasOwnProperty('lastUpdated') &&
                                                    <div className="invite-link-container">
                                                        {selectedUser.userInvitation ?
                                                            <>
                                                                <button type="button" className='blue-button'
                                                                    style={{ backgroundColor: "#3DA80A", border: "none" }}
                                                                    disabled>
                                                                    Sent
                                                                </button>
                                                                <button type="button" className='blue-button'
                                                                    style={{
                                                                        backgroundColor: "transparent",
                                                                        color: "#0082FF",
                                                                        border: "none",
                                                                        marginLeft: "5%"
                                                                    }}
                                                                    onClick={() => sendInvitation()}>
                                                                    Send Again
                                                                </button>
                                                            </> 
                                                            : <button type="button" className='blue-button'
                                                                onClick={sendInvitation}
                                                                disabled={sendLoading}>
                                                                {sendLoading ? (
                                                                    <span
                                                                        className="spinner-grow spinner-grow-sm ml-1"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    />
                                                                ) : null}
                                                                Invite Link
                                                            </button>
                                                        }
                                                    </div>
                                                }
                                                <div className="admin-form-submit-button-container">
                                                    {selectedUser?.hasOwnProperty('lastUpdated') &&
                                                        selectedUser.email !== user.email &&
                                                        <button type="button" className='red-button' data-bs-toggle="modal"
                                                            data-bs-target="#deleteAdminModal">
                                                            Remove
                                                        </button>
                                                    }

                                                    <button type="submit" className='black-button' disabled={loading}>
                                                        {loading ?
                                                            <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                                aria-hidden="true" />
                                                            : null
                                                        }
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="admin-form-button-container">
                                                {selectedUser?.hasOwnProperty('lastUpdated') &&
                                                    <>
                                                        {selectedUser.userInvitation ?
                                                            <div className="invite-link-container">
                                                                <button type="button" className='blue-button'
                                                                    style={{ backgroundColor: "#3DA80A", border: "none" }}
                                                                    disabled>
                                                                    Sent
                                                                </button>
                                                                <button type="button" className='blue-button'
                                                                    style={{
                                                                        backgroundColor: "transparent",
                                                                        color: "#0082FF",
                                                                        border: "none",
                                                                        marginLeft: "5%"
                                                                    }}
                                                                    onClick={() => sendInvitation()}>
                                                                    Send Again
                                                                </button>
                                                            </div>
                                                            : <button type="button" className='blue-button '
                                                                onClick={sendInvitation}
                                                                disabled={sendLoading}>
                                                                {sendLoading ? (
                                                                    <span
                                                                        className="spinner-grow spinner-grow-sm ml-1"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    />
                                                                ) : null}
                                                                Invite Link
                                                            </button>
                                                        }
                                                    </>
                                                }
                                                <div className="d-flex mt-3">
                                                    {selectedUser?.hasOwnProperty('lastUpdated') &&
                                                        selectedUser.email !== user.email &&
                                                        <button type="button" className='red-button mr-2' data-bs-toggle="modal"
                                                            data-bs-target="#deleteAdminModal">
                                                            Remove
                                                        </button>
                                                    }
                                                    <button type="submit" className='black-button' disabled={loading}>
                                                        {loading ?
                                                            <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                                aria-hidden="true" />
                                                            : null
                                                        }
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="modal fade" id="deleteAdminModal" tabIndex="-1"
                        aria-labelledby="deleteAdminModalLabel"
                        aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5 modelfile-title" id="deleteAdminModalLabel">Delete Admin</h1>
                                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"/> */}
                                    <button type="button" className="close-btn" data-bs-dismiss="modal" aria-label="Close">
                                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="vuesax/bold/close-circle">
                                                <g id="close-circle">
                                                    <path id="Vector" d="M13.9997 3.18311C7.57134 3.18311 2.33301 8.42144 2.33301 14.8498C2.33301 21.2781 7.57134 26.5164 13.9997 26.5164C20.428 26.5164 25.6663 21.2781 25.6663 14.8498C25.6663 8.42144 20.428 3.18311 13.9997 3.18311ZM17.9197 17.5331C18.258 17.8714 18.258 18.4314 17.9197 18.7698C17.7447 18.9448 17.523 19.0264 17.3013 19.0264C17.0797 19.0264 16.858 18.9448 16.683 18.7698L13.9997 16.0864L11.3163 18.7698C11.1413 18.9448 10.9197 19.0264 10.698 19.0264C10.4763 19.0264 10.2547 18.9448 10.0797 18.7698C9.74134 18.4314 9.74134 17.8714 10.0797 17.5331L12.763 14.8498L10.0797 12.1664C9.74134 11.8281 9.74134 11.2681 10.0797 10.9298C10.418 10.5914 10.978 10.5914 11.3163 10.9298L13.9997 13.6131L16.683 10.9298C17.0213 10.5914 17.5813 10.5914 17.9197 10.9298C18.258 11.2681 18.258 11.8281 17.9197 12.1664L15.2363 14.8498L17.9197 17.5331Z" fill="#B2B9C2" />
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                </div>
                                {selectedUser && selectedUser.hasOwnProperty('lastUpdated') &&
                                    <div className="modal-body">
                                        <p>Are you sure you want to delete Admin User {selectedUser.email}?</p>
                                        <div className="admin-form-submit-button-container modal-button-container">
                                            <button className='red-button' onClick={() => deleteAdmin()}
                                                data-bs-dismiss="modal">
                                                Remove
                                            </button>
                                            <button className='black-button' data-bs-dismiss="modal">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="profileImageModal" tabIndex="-1"
                        aria-labelledby="profileImageModalLabel"
                        aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5 modelfile-title" id="profileImageModalLabel">Upload New Profile
                                        Image</h1>
                                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"/> */}
                                    <button type="button" className="close-btn" data-bs-dismiss="modal" aria-label="Close">
                                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="vuesax/bold/close-circle">
                                                <g id="close-circle">
                                                    <path id="Vector" d="M13.9997 3.18311C7.57134 3.18311 2.33301 8.42144 2.33301 14.8498C2.33301 21.2781 7.57134 26.5164 13.9997 26.5164C20.428 26.5164 25.6663 21.2781 25.6663 14.8498C25.6663 8.42144 20.428 3.18311 13.9997 3.18311ZM17.9197 17.5331C18.258 17.8714 18.258 18.4314 17.9197 18.7698C17.7447 18.9448 17.523 19.0264 17.3013 19.0264C17.0797 19.0264 16.858 18.9448 16.683 18.7698L13.9997 16.0864L11.3163 18.7698C11.1413 18.9448 10.9197 19.0264 10.698 19.0264C10.4763 19.0264 10.2547 18.9448 10.0797 18.7698C9.74134 18.4314 9.74134 17.8714 10.0797 17.5331L12.763 14.8498L10.0797 12.1664C9.74134 11.8281 9.74134 11.2681 10.0797 10.9298C10.418 10.5914 10.978 10.5914 11.3163 10.9298L13.9997 13.6131L16.683 10.9298C17.0213 10.5914 17.5813 10.5914 17.9197 10.9298C18.258 11.2681 18.258 11.8281 17.9197 12.1664L15.2363 14.8498L17.9197 17.5331Z" fill="#B2B9C2" />
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={uploadProfileImage}>
                                        <div className="custom-file">
                                            {profileImage ?
                                                <img src={URL.createObjectURL(profileImage)} />
                                                : null
                                            }
                                            <input type="file" className="custom-file-input" accept="image/*"
                                                id="image" ref={uploadProfileImageInput}
                                                onChange={() => setProfileImage(uploadProfileImageInput.current.files[0])} />
                                            <label className="custom-file-label"
                                                htmlFor="image">
                                                <div className="image-uploader-label">
                                                    Click to upload / Drag and Drop image
                                                </div>
                                            </label>
                                        </div>
                                        <div className="admin-form-submit-button-container modal-button-container">
                                            <button className='blue-button' type="submit">
                                                Upload
                                            </button>
                                            <button type="button" className='black-button' data-bs-dismiss="modal">
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return null;
    }
}

export default ManageAdmins;
